export default "<m-frame\n    src=\"https://public.mml.io/rgb-cubes.html\"\n    sx=\"2\"\n    sy=\"3\"\n    rx=\"-45\"\n    ry=\"45\"\n></m-frame>\n";